import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Turns any axios error into a clean, user-safe message. Never surfaces raw
// 5xx/proxy HTML (e.g. Cloudflare 520 pages) or network noise to the user.
export function getFriendlyError(err, fallback = "Something went wrong. Please try again.") {
  if (err?.response) {
    const { status, data } = err.response;
    if (status >= 500) return "We were briefly unavailable — please try again in a moment.";
    const detail = data?.detail;
    if (detail != null) {
      const msg = formatApiErrorDetail(detail);
      // Ignore HTML/markup bodies that aren't real API messages.
      if (msg && !/[<>]/.test(msg)) return msg;
    }
    return fallback;
  }
  if (err?.code === "ECONNABORTED") return "That took too long — please try again.";
  return "We couldn't reach the server. Please check your connection and try again.";
}
